import { Helmet } from "react-helmet-async";
import { SITE } from "../lib/seo";

// Reusable per-page SEO / social meta. Managed at runtime by react-helmet-async.
export default function Seo({ title, description, path = "/", image, jsonLd, noindex = false }) {
  const url = `${SITE.url}${path}`;
  const urlCA = `${SITE.urlCA}${path}`;
  const ogImage = image || SITE.defaultImage;

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="en" href={url} />
      <link rel="alternate" hrefLang="fr-ca" href={urlCA} />
      <link rel="alternate" hrefLang="x-default" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
